var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M15.8,3.982,13.877,2.059,4.36,11.573,3.95,13.909,6.283,13.5Z",
    transform: "translate(0.67 0.642)",
    fill: "#f8f4e9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M19.2,18.1H.8a.8.8,0,0,0-.8.8v.9a.2.2,0,0,0,.2.2H19.8a.2.2,0,0,0,.2-.2v-.9A.8.8,0,0,0,19.2,18.1ZM3.642,16a1.012,1.012,0,0,0,.15-.012L8,15.25a.245.245,0,0,0,.133-.07l10.6-10.6a.249.249,0,0,0,0-.352L14.572.072a.254.254,0,0,0-.355,0L3.62,10.67a.254.254,0,0,0-.07.132l-.737,4.2a.837.837,0,0,0,.235.745A.847.847,0,0,0,3.642,16Zm1.685-4.36,9.067-9.065,1.833,1.832L7.16,13.472l-2.223.392Z",
    fill: "#c19444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d3411e4a7c703ff99fad18a58909cacd.svg";
export { ForwardRef as ReactComponent };